"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useRecommendationHandsets = void 0;
var _recommendationSelectors = require("../../store/recommendation/recommendationSelectors");
var _constants = require("../../utils/constants");
var _useAppSelector = require("../useAppSelector");
var _useRecommendationStatus = require("./useRecommendationStatus");
const getSelectedHandset = () => {
  const handset = (0, _useAppSelector.useAppSelector)(_recommendationSelectors.selectSelectedHandset);
  if (!handset) {
    return null;
  }
  const selectedVariant = handset.selectedVariant;
  return {
    ...handset,
    ...selectedVariant
  };
};
const getHandset = tier => {
  const handset = (0, _useAppSelector.useAppSelector)(instanceId => state => (0, _recommendationSelectors.selectHandset)(state, tier, instanceId));
  if (!handset) {
    return null;
  }
  const selectedHandsetId = (0, _useAppSelector.useAppSelector)(_recommendationSelectors.selectSelectedHandsetId);
  const selectedVariant = handset.selectedVariant;
  const isHandsetSelected = selectedHandsetId === handset.productId;
  const isMainRecommendation = tier === _constants.RECOMMENDATION_TIER.RECOMMENDED;
  return {
    ...handset,
    ...selectedVariant,
    isHandsetSelected,
    isMainRecommendation
  };
};
const useRecommendationHandsets = () => {
  const {
    areHandsetsPresent
  } = (0, _useRecommendationStatus.useRecommendationStatus)();
  if (!areHandsetsPresent) {
    return {};
  }
  const recommendedHandset = getHandset(_constants.RECOMMENDATION_TIER.RECOMMENDED);
  const premiumHandset = getHandset(_constants.RECOMMENDATION_TIER.PREMIUM);
  const budgetHandset = getHandset(_constants.RECOMMENDATION_TIER.BUDGET);
  const alternativeHandset = getHandset(_constants.RECOMMENDATION_TIER.ALTERNATIVE);
  const alternativePremiumHandset = !premiumHandset && alternativeHandset;
  const alternativeBudgetHandset = !budgetHandset && alternativeHandset;
  const selectedHandset = getSelectedHandset();
  return {
    recommendedHandset,
    premiumHandset,
    budgetHandset,
    alternativePremiumHandset,
    alternativeBudgetHandset,
    selectedHandset
  };
};
exports.useRecommendationHandsets = useRecommendationHandsets;